import api from './api.service'

export const documentationComparisonService = {
    list,
    findAllByDocumentationNameOrTag,
    manualExport,
    getProjectId
};

const BASE_URL = '/documentationComparisons'

function list(max) {
    return api.get(BASE_URL, {max: max || 1000, sort: 'dateCreated', order: 'desc'})
}

function findAllByDocumentationNameOrTag(name) {
    return api.get('/documentationComparison/findAllByDocumentationNameOrTag/' + name, {max: 100, sort: 'dateCreated', order: 'asc'})
}

function manualExport(exportRequest) {
	return api.post('/documentationComparison/manualExport/', exportRequest)
}

function getProjectId(candidateId) {
	return api.get('/documentationComparison/getProjectId/' + candidateId)
}